import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoItem = _resolveComponent("ToDoItem")!
  const _component_FileList = _resolveComponent("FileList")!
  const _component_CommentList = _resolveComponent("CommentList")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_BackButtonComponent = _resolveComponent("BackButtonComponent")!
  const _component_ToDoContent = _resolveComponent("ToDoContent")!

  return (_openBlock(), _createBlock(_component_ToDoContent, { class: "to-do-details" }, {
    content: _withCtx(() => [
      _createVNode(_component_Tab, {
        tabs: _ctx.tabs,
        control: false,
        metrics: _ctx.tabMetrics,
        changeCurrentTab: _ctx.$route.query.comment ? 'comments' : '',
        class: "to-do-details__tabs"
      }, {
        "tab-todo": _withCtx(() => [
          _createVNode(_component_ToDoItem, {
            item: _ctx.item,
            showDescriptionProp: true,
            disableCheckbox: _ctx.item.owners.every(owner => owner.id !== _ctx.currentUser.id),
            onOnCheckboxClick: _ctx.onCheckboxClick,
            onOnEdit: _ctx.onEdit
          }, null, 8, ["item", "disableCheckbox", "onOnCheckboxClick", "onOnEdit"])
        ]),
        "tab-files": _withCtx(() => [
          (_openBlock(), _createBlock(_component_FileList, {
            key: _ctx.filterFiles.withDeleted,
            files: _ctx.filesResponse.content,
            last: _ctx.filesResponse.last,
            withDeleted: _ctx.filterFiles.withDeleted,
            uploadListKey: _ctx.item.id,
            projectScoped: false,
            onDeleteFile: _ctx.onDeleteFile,
            onUpload: _ctx.onUploadFiles,
            onOnScroll: _ctx.onScrollFiles,
            onShowDeleted: _ctx.onShowDeletedFiles
          }, null, 8, ["files", "last", "withDeleted", "uploadListKey", "onDeleteFile", "onUpload", "onOnScroll", "onShowDeleted"]))
        ]),
        "tab-comments": _withCtx(() => [
          _createVNode(_component_CommentList, {
            targetId: _ctx.item.id,
            targetResourceId: _ctx.targetResourceId,
            filterForComments: _ctx.filterForComments,
            innerPagging: false,
            projectScoped: false,
            showHistoryToggle: false,
            referencesEnabled: false,
            commentsResponse: _ctx.commentsResponse,
            onFilterUpdate: _ctx.onUpdateCommentFilter,
            onCommentsResponseChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.commentsResponse = $event))
          }, null, 8, ["targetId", "targetResourceId", "filterForComments", "commentsResponse", "onFilterUpdate"])
        ]),
        _: 1
      }, 8, ["tabs", "metrics", "changeCurrentTab"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_BackButtonComponent, { onGoBack: _ctx.onBack }, null, 8, ["onGoBack"])
    ]),
    _: 1
  }))
}